import script from "./txft-stmn-dat-cnfm.vue?vue&type=script&setup=true&lang=js"
export * from "./txft-stmn-dat-cnfm.vue?vue&type=script&setup=true&lang=js"

import "./txft-stmn-dat-cnfm.vue?vue&type=style&index=0&id=61761d08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61761d08"]])

export default __exports__